import React from "react";
import { useGridApiContext, GridEditInputCell } from "@mui/x-data-grid";
import { Box, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));
const CustomEditComponent = (props) => {
  const { id, value, field, hasFocus, error, setErrors, row } = props;
  //
  setErrors(error);
  const apiRef = useGridApiContext();
  const ref = React.useRef();
  React.useLayoutEffect(() => {
    ref.current.focus();
  }, [hasFocus]);

  const handleValueChange = (event) => {
    const newValue = event.target.value; // The new value entered by the user
    apiRef.current.setEditCellValue({
      id,
      field,
      value: { ...value, data: newValue },
    });
    //apiRef.current.updateRows([{ id: id, value: {...value , data:newValue} }]);
  };

  return (
    <>
      <StyledTooltip open={!!error} title={error}>
        <TextField
          type={field === "email" || field === "emailCC" ? "email" : "text"}
          focused
          sx={{
            width: "100%",
            backgroundColor: error ? "#ff000014 !important" : "transparent",
            "& .MuiInputBase-root": {
              "& fieldset": {
                borderColor: "transparent",
              },
              "&:hover fieldset": {
                borderColor: "transparent",
              },
              "&.Mui-focused fieldset": {
                borderColor: "transparent",
              },
            },
            "& .MuiOutlinedInput": {
              border: "unset !important",
            },
          }}
          inputRef={ref}
          value={value.data}
          onChange={handleValueChange}
        />

        {/*  <GridEditInputCell ref={ref} {...props} value={value.data} onChange={handleValueChange}/>
         */}
      </StyledTooltip>
    </>
  );
};

export default CustomEditComponent;
